import { render } from "./EntraUsers.vue?vue&type=template&id=20d507f4&scoped=true"
import script from "./EntraUsers.vue?vue&type=script&lang=js"
export * from "./EntraUsers.vue?vue&type=script&lang=js"

import "./EntraUsers.vue?vue&type=style&index=0&id=20d507f4&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d507f4"]])

export default __exports__